import { render, staticRenderFns } from "./delete-product.vue?vue&type=template&id=14bcde3c&"
import script from "./delete-product.vue?vue&type=script&lang=tsx&"
export * from "./delete-product.vue?vue&type=script&lang=tsx&"
import style0 from "./delete-product.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports